import React, { Component } from 'react';
import { bool, string, func, number, arrayOf, object } from 'prop-types';

import Steps from './Steps/Steps';
import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';

import styles from './LeftSide.css';

class LeftSide extends Component {
  static propTypes = {
    highlighted: string,
    title: string,
    description: string,
    autoplay: bool,
    isPlaying: bool,
    activeSlide: number,
    handleCarousel: func,
    totalSlides: number,
    stepsTitle: string,
    steps: arrayOf(object),
    withoutCarousel: bool
  }

  render() {
    const {
      activeSlide,
      highlighted,
      title,
      description,
      autoplay,
      isPlaying,
      handleCarousel,
      totalSlides,
      stepsTitle,
      steps,
      withoutCarousel
    } = this.props;

    return (
      <div className={styles.section}>
        <h5 className={styles.title}>
          {highlighted && <span className={styles.highlight}>{highlighted} </span>}{title}
        </h5>
        <p className={styles.description}>
          {description}
        </p>

        {steps && <Steps title={stepsTitle} steps={steps} />} 

        {
          !withoutCarousel && (
            <CarouselPagination
              className={styles.carouselPagination}
              autoplay={autoplay && !isPlaying}
              totalItems={totalSlides}
              currentPage={activeSlide}
              onPageChange={handleCarousel}
              medium
            />
          )
        }
      </div>
    );
  }
}

export default LeftSide;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/MediaBanner/LeftSide/LeftSide.js